import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { BillingProvider } from "./context/BillingContext";
import Landing from "./pages/Landing";
import Room from "./pages/Room";
import Login from "./pages/Login";
import History from "./pages/History";
import Questions from "./pages/Questions";
import Pricing from "./pages/Pricing";
import BillingSuccess from "./pages/BillingSuccess";
import BillingCancel from "./pages/BillingCancel";
import BackgroundPreview from "./pages/BackgroundPreview";
import LogoPreview from "./pages/LogoPreview";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Refund from "./pages/Refund";
import Contact from "./pages/Contact";
import Chat from "./pages/Chat";
import { Navigate } from "react-router-dom";
import NotFound from "./pages/NotFound";
import PaywallSheet from "./components/PaywallSheet";
import UnlockCelebration from "./components/UnlockCelebration";
import PackPreviewModal from "./components/PackPreviewModal";
import InstallPrompt from "./components/InstallPrompt";
import AnimatedRoutes from "./components/PageTransition";
import { useBilling } from "./context/BillingContext";

function GlobalPackPreview() {
  const { previewPack, closePackPreview } = useBilling();
  return <PackPreviewModal open={!!previewPack} pack={previewPack} onClose={closePackPreview} />;
}


function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <BillingProvider>
            <Toaster
              position="top-center"
              theme="dark"
              toastOptions={{
                style: {
                  background: "rgba(26, 26, 36, 0.95)",
                  border: "1px solid rgba(255, 77, 141, 0.3)",
                  color: "#FFFFFF",
                  borderRadius: "9999px",
                  fontWeight: 600,
                  boxShadow: "0 0 30px rgba(255, 77, 141, 0.2)",
                },
              }}
            />
            <AnimatedRoutes>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/together" element={<Landing />} />
                <Route path="/remotely" element={<Landing />} />
                <Route path="/group" element={<Landing />} />
                <Route path="/join/:code" element={<Landing />} />
                <Route path="/group-join/:code" element={<Landing />} />
                <Route path="/room/:code" element={<Room />} />
                <Route path="/login" element={<Login />} />
                <Route path="/history" element={<History />} />
                <Route path="/questions" element={<Questions />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/billing/success" element={<BillingSuccess />} />
                <Route path="/billing/cancel" element={<BillingCancel />} />
                <Route path="/bg-preview" element={<BackgroundPreview />} />
                <Route path="/logo-preview" element={<LogoPreview />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/refund-policy" element={<Refund />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/chat" element={<Chat />} />
                {/* Legacy /whispers redirects to /chat */}
                <Route path="/whispers" element={<Navigate to="/chat" replace />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </AnimatedRoutes>
            <PaywallSheet />
            <UnlockCelebration />
            <GlobalPackPreview />
            <InstallPrompt />
          </BillingProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
